import React from "react";
import HeroArea from "./HeroArea";
import BlogsArea from "./BlogsArea";

const Blogs = () => {
  return (
    <>
      <HeroArea />
      <BlogsArea />
    </>
  );
};

export default Blogs;
